import 'react-quill/dist/quill.snow.css';

function mergeClassNames(...parts) {
  return parts.filter(Boolean).join(' ');
}

export default function RichTextHtml({ html, className, as: Tag = 'div', ...props }) {
  return (
    <Tag
      className={mergeClassNames('ql-editor', className)}
      dangerouslySetInnerHTML={{ __html: html || '' }}
      {...props}
    />
  );
}
